import styled from 'styled-components';

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(${props => (props.isMobile ? 2 : 3)}, 1fr);
    grid-row-gap: 24px;
`;

export const Feature = styled.div`
    display: grid;
    align-items: center;
    grid-template-columns: 0.2fr 1fr;
`;

export const Detail = styled.div`
    display: flex;
    flex-direction: column;

    :not(.fullwidth-detail) {
        flex: 0 0 ${props => (props.mobile || props.columns === 2 ? '50%' : '33.3%')};
    }

    &.fullwidth-detail {
        flex-basis: 100%;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
`;
